var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_c('h1',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('legal.termsTitle')))]),_vm._v(" "),_c('div',{staticClass:"card-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }